module.exports = __webpack_public_path__ + "img/female.6697ab9e.svg";